import { Component, Input } from "@angular/core";
import { Table } from "../Table";
import { S25ButtonComponent } from "../../../standalone/s25.button.component";
import { PopoverModule } from "../../s25-popover/popover.module";
import { S25TableModule } from "../s25.table.module";

@Component({
    template: `
        <s25-popover [popoverTemplate]="popoverContent" [openTrigger]="'click'" [closeTrigger]="'click'">
            <button class="aw-button aw-button--outline">{{ label }}</button>
        </s25-popover>

        <ng-template #popoverContent>
            <s25-ng-table-cell [defaults]="cell" />
        </ng-template>
    `,
    standalone: true,
    imports: [PopoverModule, S25TableModule],
})
export class TablePopoverButtonComponent {
    @Input({ required: true }) cell: Table.Cell;
    @Input() label: string;
    @Input() type?: S25ButtonComponent["type"] = "outline";
    @Input() disabled?: boolean;
    @Input() disabledReason: string;
}
